export default function MarketCommunities() {
  return (
    <section
      data-testid="market-communities"
      className="py-24 md:py-36 bg-cream-deep/50"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6 lg:gap-10">
        {/* Marketplace */}
        <div className="col-span-12 md:col-span-7 border hairline rounded-2xl bg-cream p-8 md:p-12 lg:p-14 lift">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
            ◊ Marketplace moderno
          </p>
          <h3 className="mt-4 font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tighter">
            Vender ya no <span className="italic">requiere otra app</span>.
          </h3>
          <p className="mt-6 text-base md:text-lg text-ink/75 leading-relaxed max-w-2xl">
            Productos físicos, digitales, servicios, cursos, eventos, reservas. Pagos integrados, envíos transparentes, reseñas verificadas. Tu negocio vive donde vive tu comunidad.
          </p>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-px bg-ink/10 rounded-xl overflow-hidden border hairline">
            {[
              { t: "Físicos", e: "◷" },
              { t: "Digitales", e: "◊" },
              { t: "Servicios", e: "✕" },
              { t: "Eventos", e: "✦" },
            ].map((c) => (
              <div key={c.t} className="bg-cream p-6 hover:bg-coral hover:text-cream transition-colors duration-500 group">
                <div className="font-serif text-3xl">{c.e}</div>
                <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em]">
                  {c.t}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Communities */}
        <div className="col-span-12 md:col-span-5 border hairline rounded-2xl bg-ink text-cream p-8 md:p-12 lg:p-14 lift relative overflow-hidden">
          <div className="grain absolute inset-0 opacity-25 pointer-events-none" />
          <div className="relative">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
              ◊ Comunidades vivas
            </p>
            <h3 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[0.98] tracking-tighter">
              Donde la gente <br /> <span className="italic">sí se queda.</span>
            </h3>
            <p className="mt-6 text-base text-cream/75 leading-relaxed">
              Por intereses, ciudades, profesiones, causas. Moderación humana asistida por IA. Reglas claras, alcance orgánico, eventos reales.
            </p>

            <ul className="mt-10 space-y-4">
              {[
                "Creadores que comparten sin algoritmos hostiles",
                "Padres que filtran tóxicos automáticamente",
                "Profesionales que descubren oportunidades reales",
                "Viajeros que conectan con locales verificados",
              ].map((c, i) => (
                <li key={i} className="flex items-start gap-4 border-b border-cream/10 pb-4">
                  <span className="font-mono text-[10px] text-coral">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-sm text-cream/85">{c}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
